import { render, staticRenderFns } from "./plm-downLoad.vue?vue&type=template&id=4edfbe02&scoped=true"
import script from "./plm-downLoad.vue?vue&type=script&lang=js"
export * from "./plm-downLoad.vue?vue&type=script&lang=js"
import style0 from "./plm-downLoad.vue?vue&type=style&index=0&id=4edfbe02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edfbe02",
  null
  
)

export default component.exports